import { defineClassNames } from '../utils/defineClassNames';

export const classes = defineClassNames('radio', {
  root: {
    variants: {
      size: ['small', 'medium'],
      alignItems: ['center', 'top'],
    },
    states: ['checked', 'disabled', 'animated'],
  },
  input: {},
  dotContainer: {},
  dot: {},
  label: {},
  labelText: {},
});
